import { useEffect, useState } from "react";

import { getUserData } from "../services/firebase";

/**
 * Hook for user data by user
 *
 * @param {*} user
 * @returns undefined if not loaded, null if anonymous
 */
function useUserData(user) {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (user) {
      const unsubscribe = getUserData(user, setUserData);
      return () => unsubscribe();
    }

    setUserData(null);
    return () => {};
  }, [user]);

  return userData;
}

export { useUserData };
